import { render, staticRenderFns } from "./noticeDetailNew.vue?vue&type=template&id=56ae6723&scoped=true"
import script from "./noticeDetailNew.vue?vue&type=script&lang=js"
export * from "./noticeDetailNew.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailNew.vue?vue&type=style&index=0&id=56ae6723&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae6723",
  null
  
)

export default component.exports